import { ChainContext } from 'containers/WalletProvider/ChainProvider';
import { useContext } from 'react';

const useSelectedChain = () => {
  return useContext(ChainContext);
};

export default useSelectedChain;
